import { useMediaQuery, useTheme } from '@mui/material';

// Sizing for tall "workspace" dialogs: full screen on phones, an inset card on
// desktop.
//
// Never size these in `vh`. Mobile Chrome reports `vh` as the viewport height
// with the URL bar hidden, so a `95vh` paper is taller than the dialog
// container and MUI centres the overflow — clipping the top out of reach.
// Percentages resolve against the container, which tracks the visible viewport.
// See the matching note in index.css.
//
//   const { fullScreen, paperSx } = useTallDialogSizing({ height: '95vh' });
//   <Dialog fullScreen={fullScreen} PaperProps={{ sx: { ...paperSx } }}>
//
// `height`, `margin` and `radius` describe the desktop card only. Pass the
// values the dialog already used so desktop stays exactly as it was; `radius`
// defaults to the MUI paper default.
export function useTallDialogSizing({ height = '95vh', margin = 1.5, radius } = {}) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  return {
    fullScreen: mobile,
    paperSx: {
      height: mobile ? '100%' : height,
      maxHeight: mobile ? '100%' : height,
      m: mobile ? 0 : margin,
      borderRadius: mobile ? 0 : radius,
      display: 'flex',
      flexDirection: 'column',
    },
  };
}

export default useTallDialogSizing;
